import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/storefront/src/components/SkipLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/apps/storefront/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/vercel/path0/apps/storefront/src/contexts/CartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/storefront/src/lib/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/storefront/src/styles/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/.pnpm/@vercel+analytics@2.0.1_next@15.5.19_@babel+core@7.29.7_@playwright+test@1.59.1_react-d_a80bbe3f9ade8e5ba259ec47bb52b104/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@2.0.0_next@15.5.19_@babel+core@7.29.7_@playwright+test@1.59.1_re_413c2af0c87c5b74737a80afc57967eb/node_modules/@vercel/speed-insights/dist/next/index.mjs");
